import { Observable } from 'rxjs'
import { apiUrl } from '../config/settings'
import { push } from 'react-router-redux'
import { authTypes, errorTypes, generalTypes, popupTypes } from '../actions'
import { Auth, Headers } from '../helpers'
var OneSignal = window.OneSignal || []

export const attemptEpic = (action$) => {
  return action$.ofType(authTypes.ATTEMPT)
    .switchMap(action => {
      return Observable
        .ajax(
          {
            url: `${apiUrl}/auth/login`,
            method: 'POST',
            headers: Headers.get(),
            body: action.credentials
          }
        )
        .map(res => ({ type: authTypes.RESPONSE, payload: res.response }))
        .catch(err => window.alert(err))
    })
}
// ADD ID TO USER HERE
export const responseEpic = (action$) => {
  return action$.ofType(authTypes.RESPONSE)
    .switchMap(action => {
      return Observable
        .create(obs => {
          const { success } = action.payload
          if (success) {
            const { token, user } = action.payload
            Auth.authenticateUser(token, user)
            obs.next({ type: authTypes.SUCCESS, user: user })
            obs.complete()
          }

          obs.next({ type: authTypes.FAIL })
          obs.next({ type: errorTypes.DISPLAY, err: action.payload.err })
          obs.complete()
        })
        .catch(err => window.alert(err))
    })
}

export const applyWebPushToken = (action$) => {
  return action$.ofType(authTypes.SUCCESS)
    .switchMap(({ user }) => {
      return Observable
        .create(obs => {
          if (OneSignal.isPushNotificationsEnabled) {
            OneSignal.isPushNotificationsEnabled(function (isEnabled) {
              if (isEnabled && user) {
                OneSignal.sendTag('user_id', user._id)
                OneSignal.sendTag('real_name', user.name)
                OneSignal.sendTag('email', user.email)
                OneSignal.getUserId(function (userId) {
                  // console.log('player_id of the subscribed user is : ', userId)
                  obs.next({ type: 'webPush/SEND_TO_SERVER', id: user._id, push_token: userId })
                  obs.complete()
                })
              } else {
                obs.next({ type: 'webPush/NO_PERMISSION' })
                obs.complete()
              }
            })
          } else {
            obs.next({ type: 'exception/OneSignal_SLOW', user: user })
            obs.complete()
          }
        })
    })
}

export const OneSignalSlowLoad = (action$) => {
  return action$.ofType('exception/OneSignal_SLOW')
    .switchMap(({ user }) => {
      // console.log("USER::::::::::::;", user, '\n\n\n\n\n\n')
      if (!user) return Observable.of({ type: 'DEAD_END_STUFF' })
      return Observable.of({ type: 'webPush/DELAYED', user: user }).delay(1000)
    })
}

export const applyWebPushTokenDelayed = (action$) => {
  return action$.ofType('webPush/DELAYED')
    .switchMap(({ user }) => {
      return Observable
        .create(obs => {
          console.log('OBSERVABLEEEE!!!')
          OneSignal.isPushNotificationsEnabled(function (isEnabled) {
            if (isEnabled && user) {
              console.log('NOW IT SHOULD GO IN THERE!')
              OneSignal.sendTag('user_id', user._id)
              OneSignal.sendTag('real_name', user.name)
              OneSignal.sendTag('email', user.email)
              OneSignal.getUserId(function (userId) {
                console.log('player_id of the subscribed user is : ', userId)
                obs.next({ type: 'webPush/SEND_TO_SERVER', id: user._id, push_token: userId })
                obs.complete()
              })
            } else {
              obs.next({ type: 'webPush/NO_PERMISSION' })
              obs.complete()
            }
          })
        })
    })
}

export const sendWebPushToken = (action$) => {
  return action$.ofType('webPush/SEND_TO_SERVER')
    .switchMap(({ id, push_token }) => {
      // console.log('SEND HERE::', id, push_token)
      return Observable
        .ajax({
          url: `${apiUrl}/web-push/save-token`,
          method: 'POST',
          headers: Headers.get(),
          body: JSON.stringify({ user_id: id, token: push_token })
        })
        .map(res => ({ type: 'webPush/SENT', payload: res.response }))
        .catch(err => ({ type: 'webPush/SERVER_ERROR', err: err }))
    })
}

// REMOVE ID FROM USER HERE!
export const failEpic = (action$) => {
  return action$.ofType(authTypes.FAIL)
    .switchMap(() => {
      return Observable
        .create(obs => {
          let user = Auth.getUser()
          Auth.deauthenticateUser()
          obs.next({ type: 'webPush/SEND_TO_SERVER', id: user._id, push_token: null })
          obs.complete()
        })
        .catch(err => window.alert(err))
    })
}

export const syncEpic = (action$) => {
  return action$.ofType(authTypes.SYNC)
    .switchMap(action => {
      return Observable
        .ajax(
          {
            url: `${apiUrl}/auth/sync`,
            method: 'POST',
            headers: Headers.getWithAuth(),
            body: action.profileData
          }
        )
        .map(res => ({ type: authTypes.SYNC_RESPONSE, payload: res.response }))
        .catch(err => window.alert(err))
    })
}

export const syncResEpic = (action$) => {
  return action$.ofType(authTypes.SYNC_RESPONSE)
    .switchMap(action => {
      return Observable
        .create(obs => {
          const { success } = action.payload
          if (success) {
            Auth.setSocialAccountsInfo(action.payload.social_accounts)
            Auth.setAvatar(action.payload.avatar)
            obs.next({ type: authTypes.SUCCESS })
            obs.next({ type: generalTypes.DISPLAY_ALERT, text: 'Successfull sync.' })
          } else {
            obs.next({ type: generalTypes.DISPLAY_ALERT, text: 'An error occurred while saving your info.' })
          }
          obs.complete()
        })
    })
}

export const leaveHackathonEpic = (action$) => {
  return action$.ofType(authTypes.LEAVE_HACKATHON)
    .switchMap(action => {
      return Observable
        .ajax(
          {
            url: `${apiUrl}/auth/leave`,
            method: 'GET',
            headers: Headers.getWithAuth()
          }
        )
        .map(res => ({ type: authTypes.LEAVE_RESPONSE, payload: res.response }))
        .catch(err => window.alert(err))
    })
}

export const leaveRespEpic = (action$) => {
  return action$.ofType(authTypes.LEAVE_RESPONSE)
    .switchMap(action => {
      return Observable
        .create(obs => {
          const { success } = action.payload
          if (success) {
            obs.next({ type: authTypes.FAIL })
            obs.next({ type: popupTypes.SWITCH_LEAVE_HACKATHON })
            obs.next(push('/left'))
          } else {
            obs.next({ type: generalTypes.DISPLAY_ALERT, text: 'An error occurred.' })
          }
          obs.complete()
        })
    })
}

export const sendActivationCodeEpic = (action$) => {
  return action$.ofType(authTypes.SEND_ACTIVATION_CODE)
    .switchMap(action => {
      return Observable
        .ajax(
          {
            url: `${apiUrl}/register/code/${action.email}`,
            method: 'GET',
            headers: Headers.get()
          }
        )
        .map(res => ({ type: authTypes.SEND_CODE_RES, payload: res.response }))
        .catch(err => window.alert(err))
    })
}

export const sendCodeResEpic = (action$) => {
  return action$.ofType(authTypes.SEND_CODE_RES)
    .switchMap(action => {
      return Observable
        .create(obs => {
          const { success } = action.payload
          if (success) {
            obs.next({ type: errorTypes.DISPLAY, err: 'Activation code sent. Please check your inbox.' })
          } else {
            obs.next({ type: errorTypes.DISPLAY, err: action.payload.err })
          }
          obs.complete()
        })
    })
}



// WEBPACK FOOTER //
// ./src/epics/auth.js